import React, {useState, useEffect, useRef} from "react";
import {Card, CardBody, Container, Row, Col} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, Button, DatePicker, Pagination, Tag} from "antd";

import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import AuthService from "../login/AuthService";
import moment from "moment";
import "moment/locale/pt-br";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
import './assets/css/Hospital.css';

import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";
import HospitalModal from "./HospitalModal";
import LoadingScreen from "../util/LoadingScreen";
import CustomPagination from "../util/CustomPagination";
import HospitalDepartmentModal from "./HospitalDepartmentModal";
import HospitalValueModal from "./HospitalValueModal";
import HospitalRegisterModal from "./HospitalRegisterModal";


moment.locale('pt-br');

const HospitalUser = () => {
    document.title = "Configuração Hospital | Plantão Rápido";
    const hospitalSearchRef = useRef(null);
    const [loadingHospitals, setLoadingHospitals] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [showHospitalModal, setShowHospitalModal] = useState(false);
    const [showHospitalValueModal, setShowHospitalValueModal] = useState(false);

    const [showHospitalManagersModal, setShowHospitalManagersModal] = useState(false);
    const [hospitalSelectManagers, setHospitalSelectManagers] = useState(false);

    const [showHospitalDepartmentModal, setShowHospitalDepartmentModal] = useState(false);
    const [showModalHospitalRegister, setShowModalHospitalRegister] = useState(false);
    const [hospitalSelectDepartment, setHospitalSelectDepartment] = useState(null);
    const [hospitalUserSelect, setHospitalUserSelect] = useState(null);
    const [assistant, setAssistant] = useState(null);

    const user = AuthService.getUserData();
    const [usersHospital, setUsersHospital] = useState([]);
    const [filters, setFilters] = useState({
        dateRange: "",
        status: null,
        hospital: "",
    });

    const options = [
        {value: "S", label: "Ativo"},
        {value: "N", label: "Inativo"},
    ];


    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});


    const handlePageChange = (page) => {
        fetchHospitalsUser(page);
    };

    const fetchHospitalsUser = async (page = 1) => {
        try {
            setLoadingHospitals(true);
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}hospitals/users-list`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    status: filters?.status?.value,
                    hospital_id: filters?.hospital
                },
                true
            );


            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setUsersHospital(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});


        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingHospitals(false);
        }
    };


    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            // Somente atualiza o filtro se o hospital tiver um ID válido
            setFilters((prevFilters) => ({
                ...prevFilters,
                hospital: hospital.value
            }));
        } else {
            // Se nenhum hospital for selecionado (hospital é null), limpe o filtro
            setFilters((prevFilters) => ({
                ...prevFilters,
                hospital: null
            }));
        }
    };


    const handleHospitalSelect = async (hospital) => {
        // Verificando se o hospital está correto
        if (hospital && hospital.value) {
            try {
                // Enviar requisição para registrar o hospital para o usuário
                setLoadingPage(true);
                const response = await ApiService.send(
                    "put", // Alterei para "post" caso esteja criando o registro
                    `${process.env.REACT_APP_URL_API}hospitals/users-register`,
                    {hospital_id: hospital.value},
                    true
                );

                Swal.fire('Sucesso', 'Hospital registrado com sucesso!', 'success')
                    .then((result) => {
                        handleHospitalModalClose();
                        fetchHospitalsUser(pagination.current);
                        if (hospitalSearchRef.current) {
                            hospitalSearchRef.current.reloadHospitals(); // Força recarregamento do <HospitalSearch />
                        }
                    });

            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoadingPage(false);
            }
        } else {
            Swal.fire('Erro', 'Hospital não selecionado corretamente', 'error');
        }
    };


    const handleStatus = async (id, statusAlterar) => {
        // Verificando se o hospital está correto
        try {
            // Enviar requisição para registrar o hospital para o usuário
            setLoadingPage(true);
            const response = await ApiService.send(
                "post", // Alterei para "post" caso esteja criando o registro
                `${process.env.REACT_APP_URL_API}hospitals/users-status`,
                {
                    hospital_id: id,
                    status: statusAlterar
                },
                true
            );
            setLoadingPage(false);
            if (response.code === 200) {
                Swal.fire('Sucesso', 'Hospital Alterado com sucesso!', 'success');
                const updatedUsersHospital = usersHospital.map(hospital => {
                    if (hospital.hospital.id === id) {
                        return {
                            ...hospital,
                            status: statusAlterar
                        };
                    }
                    return hospital;
                });

                setUsersHospital(updatedUsersHospital);
            } else {
                Swal.fire('Erro', 'Erro ao registrar hospital', 'error');
            }
        } catch (error) {
            setLoadingPage(false);
            ApiService.handleApiError(error);
        }finally {
            setLoadingPage(false);
        }

    };

    const handleCompanyAssistant = async () => {

        try {
            // Enviar requisição para registrar o hospital para o usuário
            setLoadingPage(true);
            const response = await ApiService.send(
                "get", // Alterei para "post" caso esteja criando o registro
                `${process.env.REACT_APP_URL_API}users/list-assistant`,
                null,
                true
            );
            const {data} = ApiService.handleApiResponse(response);
            console.log(data);
            setAssistant(data);

        } catch (error) {
            setLoadingPage(false);
            ApiService.handleApiError(error);
        }finally {
            setLoadingPage(false);
        }

    };

    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            status: null,
            hospital: null,
        });

        // Chamar a função clearHospital() no HospitalSearch
        if (hospitalSearchRef.current) {
            hospitalSearchRef.current.clearHospital();
        }
    };


    const handleRegister = () => {
        setShowHospitalModal(true);
    };

    const handleDepartment = (hospital) => {
        setShowHospitalDepartmentModal(true);
        setHospitalSelectDepartment(hospital);
    };

    const handleValueHospital = (hospital) => {
        setShowHospitalValueModal(true);
        setHospitalUserSelect(hospital);
    };


    const handleHospitalModalClose = (save = false) => {
        setShowHospitalModal(false);
        if (save) {
            fetchHospitalsUser(pagination.current);
        }
    };


    const handleEditHospital = (hospital) => {
        setShowModalHospitalRegister(true);
        setHospitalUserSelect(hospital);
    };

    const handleCloseModalRegister = (save = false) => {
        setShowModalHospitalRegister(false);
        if (save) {
            fetchHospitalsUser(pagination.current);
        }
    };

    const handleHospitalDepartmentModalClose = () => {
        setShowHospitalDepartmentModal(false);
    };

    const handleHospitalValueModalClose = (save = false, hospitalUser) => {

        if (save && hospitalUser) {
            setUsersHospital((prev) => {
                const index = prev.findIndex((h) => h.hospital.id === hospitalUser.hospital.id);
                if (index !== -1) {
                    const updated = [...prev];
                    updated[index] = {
                        ...updated[index],
                        value: hospitalUser.value // atualiza o valor
                    };
                    return updated;
                } else {
                    return [...prev, hospitalUser]; // adiciona novo se não existe
                }
            });
        }
        setShowHospitalValueModal(false);
    };

    const handleHospitalManagersModalClose = () => {
        setShowHospitalManagersModal(false);
    };

    useEffect(() => {
        fetchHospitalsUser(1);
        handleCompanyAssistant();
    }, []);

    const handleChange = (selectedOption) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            status: selectedOption,
        }));
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Locais" pageTitle="Configuração"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>} {/* Exibe o LoadingScreen durante operações */}
                        <Row>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Situação</label>
                                    <Select
                                        key={filters.status ? "has-value" : "no-value"} // Altera a key ao limpar
                                        options={options}
                                        value={filters.status} // Garante que o valor seja atualizado corretamente
                                        onChange={handleChange}
                                        placeholder="Selecione"
                                        isClearable
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                            }),
                                        }}
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="col-md-8">
                                <HospitalSearch
                                    buttonAdd={false}
                                    ref={hospitalSearchRef}
                                    onHospitalSelect={onHospitalSelect}
                                    validateManager={true}
                                    cache={false}

                                />
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12 d-flex justify-content-end">

                                    <button type="button" className="btn  mr-1  me-2"
                                            onClick={() => handleClearFilters()}>
                                        <i className="fa fa-eraser"></i> Limpar Filtros
                                    </button>
                                    {user.users_type_id !== 1 && (
                                        <button type="button" className="btn btn-info mr-1  me-2"
                                                onClick={() => handleRegister()}>
                                            <i className="fa fa-plus"></i> Cadastrar
                                        </button>
                                    )}
                                    <button type="button"
                                            className="btn btn-success"
                                            onClick={() => fetchHospitalsUser(1)}
                                            disabled={loadingHospitals}
                                    >
                                        <i className={`fa ${loadingHospitals ? "spinner-border spinner-border-sm me-2" : "fa-search"}`}></i>{" "}
                                        {loadingHospitals ? "Buscando..." : "Buscar"}
                                    </button>
                                </div>
                            </div>


                        </Row>


                        <div className="list-container mt-4">
                            {loadingHospitals ? (
                                <>
                                    <div className="card duty-card shadow-sm mb-3">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-3">
                                                    <Skeleton width={150} height={150}/>
                                                </div>
                                                <div className="col-9">
                                                    <Skeleton width={200}/>
                                                    <p>
                                                        <Skeleton width={200}/>
                                                    </p>
                                                    <p className="card-text">
                                                        <Skeleton width={200}/>
                                                    </p>
                                                    <p className="card-text">
                                                        <Skeleton width={200}/>
                                                    </p>
                                                    <p className="card-text">
                                                        <Skeleton width={200}/>
                                                    </p>
                                                    <p className="card-text">
                                                        <Skeleton width={200}/>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (


                                usersHospital.length > 0 ? (
                                    usersHospital.map((result) => (
                                        <Col lg={12} key={result.id}>
                                            <Card className="mb-1 p-2 shadow-sm card-hover">
                                                <CardBody
                                                    className="card-body d-flex justify-content-between align-items-center p-2">
                                                    <div className="col-2 doctor-img">
                                                        <a target="_blank"
                                                           href={`/admin/location-detail/${result.hospital.url_page}`}>
                                                            <img
                                                                src={result.hospital.images?.[0]?.file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                                                className="img-fluid rounded"
                                                                width={100}
                                                                alt={result.hospital.name || "Hospital não especificado"}
                                                            />
                                                        </a>
                                                    </div>
                                                    <div
                                                        className="col-12  col-md-12 col-lg-8 col-xs-8  mt-3 doc-info">
                                                        <strong className="doc-name">
                                                            <a target="_blank"
                                                               style={{
                                                                   textDecoration: 'none',
                                                                   color: '#6c757d', // azul Bootstrap
                                                               }}
                                                               href={`/admin/location-detail/${result.hospital.url_page}`}>
                                                                {result.hospital.name || result.hospital.social_reason || "Hospital não especificado"}
                                                            </a>
                                                        </strong>


                                                        <p className="text-muted mb-1">
                                                            {result.status === 1 ? (
                                                                <span
                                                                    className="badge bg-success d-inline-flex align-items-center">
                                                                                  <i className="fa fa-check me-2"></i> Status Ativo
                                                                                </span>
                                                            ) : (
                                                                <span
                                                                    className="badge bg-danger d-inline-flex align-items-center">
                                                                                      <i className="fa fa-times me-2"></i> Status Inativo
                                                                                    </span>

                                                            )}
                                                        </p>

                                                        <div className="row">
                                                            <div className="col-6">
                                                                <p className="text-muted mb-1">
                                                                    <i className="fa fa-map-marker text-info"
                                                                       style={{marginRight: "8px"}}></i>
                                                                    {result.hospital.street_name || "Endereço não especificado"}{"  "}
                                                                    {result.hospital.address_number || "S/N "}
                                                                    {result.hospital.complement_name || " "}
                                                                    {result.hospital.neighborhood_name || "Bairro não especificado"}

                                                                </p>

                                                                {/* Exibindo número de telefone */}
                                                                {result.hospital.phone_number && (
                                                                    <p className="text-muted mb-1">
                                                                        <i className="fa fa-phone text-info"
                                                                           style={{marginRight: "8px"}}></i>
                                                                        {result.hospital.phone_number}
                                                                    </p>
                                                                )}

                                                                {/* Exibindo o e-mail do hospital */}
                                                                {result.hospital.email_address && (
                                                                    <p className="text-muted mb-1">
                                                                        <i className="fa fa-envelope text-info"
                                                                           style={{marginRight: "8px"}}></i>
                                                                        {result.hospital.email_address}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <div className="col-6">
                                                                {/* Exibindo o CNPJ do hospital */}
                                                                {result.hospital.cnpj_number && (
                                                                    <p className="text-muted mb-1">
                                                                        <i className="fa fa-cogs text-info"
                                                                           style={{marginRight: "8px"}}></i>
                                                                        CNPJ: {result.hospital.cnpj_number}
                                                                    </p>
                                                                )}
                                                                {result.value && (
                                                                    <p className="text-muted mb-1">
                                                                        <i className="fa fa-dollar text-info"
                                                                           style={{marginRight: "8px"}}></i>
                                                                        {result.value?.toLocaleString('pt-BR', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })} reais
                                                                    </p>
                                                                )}

                                                                {/* Exibindo a cidade */}
                                                                <p className="text-muted mb-1">
                                                                    <i className="fa fa-city text-info"
                                                                       style={{marginRight: "8px"}}></i>
                                                                    {result.hospital.city_name || "Cidade não especificada"} {result.hospital.uf}
                                                                </p>


                                                            </div>

                                                        </div>


                                                    </div>
                                                    <div className="row col-2 d-flex align-items-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary w-100 btn-sm mb-2" // Adicionada a classe w-100 e mb-2 para espaçamento
                                                            onClick={() => handleDepartment(result.hospital)}>
                                                            <i className="fa fa-user"></i> Vagas Escala Padrão
                                                        </button>


                                                        {user.users_type_id !== 1 && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-success w-100 btn-sm mb-2" // Adicionada a classe w-100 e mb-2 para espaçamento
                                                                    onClick={() => handleValueHospital(result)}>
                                                                    <i className="fa fa-dollar"></i> Valor Hora
                                                                </button>

                                                                {assistant?.can_edit_hospitals === 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-info w-100 btn-sm mb-2"
                                                                        onClick={() => handleEditHospital(result)}>
                                                                        <i className="fa fa-edit"></i> Editar
                                                                    </button>
                                                                )}

                                                                {result.status === 1 ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger btn-sm w-100 mb-2" // Adicionada a classe w-100 e mb-2 para espaçamento
                                                                        onClick={() => handleStatus(result.hospital.id, 0)}>
                                                                        <i className="fa fa-close"></i> Inativar
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-primary btn-sm w-100 mb-2" // Adicionada a classe w-100 e mb-2 para espaçamento
                                                                        onClick={() => handleStatus(result.hospital.id, 1)}>
                                                                        <i className="fa fa-check"></i> Ativar
                                                                    </button>
                                                                )}
                                                            </>

                                                        )}
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))
                                ) : (
                                    <div className="alert alert-primary" role="alert">
                                        Nenhum hospital encontrado.
                                    </div>
                                )


                            )}
                        < /div>


                        <CustomPagination
                            pagination={pagination}
                            onChange={handlePageChange}
                        />


                        <HospitalModal
                            actionText="Registrar"
                            show={showHospitalModal}
                            handleClose={handleHospitalModalClose}
                            onHospitalSelect={handleHospitalSelect}
                        />
                        {showHospitalManagersModal && (
                            <HospitalManagersModal
                                show={showHospitalManagersModal}
                                handleClose={handleHospitalManagersModalClose}
                                hospital={hospitalSelectManagers}
                            />
                        )}

                        <HospitalDepartmentModal
                            show={showHospitalDepartmentModal}
                            handleClose={handleHospitalDepartmentModalClose}
                            hospital={hospitalSelectDepartment}
                        />

                        <HospitalValueModal
                            show={showHospitalValueModal}
                            handleClose={handleHospitalValueModalClose}
                            hospitalUser={hospitalUserSelect}
                        />

                        <HospitalRegisterModal show={showModalHospitalRegister} id={hospitalUserSelect?.hospitals_id}
                                               onHide={handleCloseModalRegister}
                        />

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default HospitalUser;
